import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import date from '../../../assets/icons/e-learning/user/date.svg'
import ment from '../../../assets/icons/e-learning/user/comment.svg'
import book from '../../../assets/icons/e-learning/user/book.svg'
import time from '../../../assets/icons/e-learning/user/time.svg'
import arrow from '../../../assets/icons/e-learning/arrow.svg'
import key from '../../../assets/icons/e-learning/user/key.svg'
import * as api from '../../services/api'
import Loader from 'components/Loader';

function ShowCourse() {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [inform, setInform] = useState([])
    const [property, setProperty] = useState([])
    const [open, setOpen] = useState(Array.from(property, () => false));

    const [groupCode, setGroupCode] = useState('')
    const [code, setCode] = useState('')

    const [registerNumber, setRegisterNumber] = useState(null)

    useEffect(() => {
        let detail = location.state
        setInform(detail)
        setProperty(detail['properties'])
        setGroupCode(detail['e_learning_group_code'])
        setCode(detail['e_learning_code'])
        console.log(detail)
    }, [])

    const toggle = (index, value) => {
        const newOpenState = [...open]
        newOpenState[index] = value ?? !newOpenState[index]
        setOpen(newOpenState)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const handleClickRegisterCourse = () => {
        // console.log(groupCode, code)
        registerCourse()
    }

    const registerCourse = async () => {
        setLoading(true)
        let res = await api.registerCourse(groupCode, code)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data'])
                setRegisterNumber(res['data']['data']['register_number'])
                navigate('/testBeforeClass', { state: { item: inform, button: "1", register_number: res['data']['data']['register_number'] } })
            } else if (res['data']['code'] === 999 && res['data']['message'] == "ลงทะเบียนไม่สำเร็จ") {
                alert('ท่านเคยลงทะเบียนเรียนหลักสูตรนี้แล้ว')
            }
            else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageUserELearning') }}
                    >กลับไป ห้องเรียนออนไลน์</Box>
                </Box>

                <Box>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: '20px'
                    }}>{inform['e_learning_name']}</Typography>
                </Box>

                <Box sx={{
                    display: 'flex',
                    gridGap: '10px',
                    "@media (max-width: 800px)": {
                        display: 'grid'
                    },
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={date} />สร้างเมื่อ {convertDate(inform['created_date'])}</Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={ment} />จำนวน {inform['properties'] ? inform['properties'].length : '0'} บทเรียน</Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={ment} />เวลารวม {inform['e_learning_hour']} ชั่วโมง</Box>
                </Box>

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gridGap: '20px',
                    "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                    },
                }}>
                    <Box>
                        <img style={{ borderRadius: '10px', width: '100%' }} src={inform['e_learning_image']} />
                        <Box>{inform['e_learning_detail']}</Box>
                    </Box>
                    <Box>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            display: 'grid',
                            gridGap: '10px',
                            padding: '10px'
                        }}>
                            <Typography sx={{ fontWeight: 600, color: '#478F96' }}>รายละเอียดบทเรียน</Typography>
                            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                {property.map((item, index) => (
                                    <Box sx={{
                                        border: '1px solid #C8EBEB',
                                        borderRadius: '10px',
                                        padding: '5px'
                                    }} key={index}>
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            {/* <Typography sx={open[index] ? { color: '#478F96', fontWeight: 600 } : { color: '#252641', fontWeight: 600 }}>บทที่ {index + 1}</Typography> */}
                                            <Typography sx={{ color: '#478F96', fontWeight: 600 }}>บทที่ {index + 1}</Typography>
                                            {/* <img
                                                src={arrow}
                                                style={open[index] ? { transform: 'rotate(180deg)', cursor: 'pointer', width: '20px' } : { cursor: 'pointer', width: '20px' }}
                                                onClick={() => { toggle(index) }}
                                            /> */}
                                        </Box>
                                        <Box>{item['title']}</Box>
                                        {/* {!open[index] ?
                                            <>
                                            </>
                                            :
                                            <>
                                                <Box>{item['title']}</Box>
                                            </>
                                        } */}
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button variant='contained' onClick={() => { handleClickRegisterCourse() }} >เริ่มเข้าเรียน</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gridGap: '10px' }}>
                    <Box>แท็ก:</Box>
                    <Box sx={{ border: '1px solid #EAEAEA', borderRadius: '5px', padding: '0 5px' }}>{inform['e_learning_keyword']}</Box>
                </Box>

            </Box>
        </>
    )
}

export default ShowCourse
